import { debounce } from "lodash";
import { useCallback, useState } from "react";
import Skeleton from "react-loading-skeleton";
import styled from "styled-components";

import { faPlus } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Direction, Flex } from "@ntemarked/mittne-components/dist/Flex/Flex";

import { InfoColumn, InfoRow } from "components/atoms/InfoRow";
import { useAddUserToGroupMutation } from "pages/Features/Grupper/Groups.graphql-gen";
import { usePaginateUsersQuery } from "pages/Users/Users.graphql-gen";

interface AddUserModalProps {
	groupId?: string;
}
export function AddUserModal(props: AddUserModalProps) {
	const [search, setSearch] = useState("");

	const { data, loading } = usePaginateUsersQuery({
		variables: {
			search: (!!search && search) || undefined,
			count: 20,
		},
	});

	// eslint-disable-next-line react-hooks/exhaustive-deps
	const onSearchUpdate = useCallback(
		debounce((newSearch: string) => setSearch(newSearch), 200),
		[]
	);

	const [addUserToGroup, { loading: addUserLoading }] = useAddUserToGroupMutation();

	return (
		<FindUserModalContentWrapper direction={Direction.column} gap="calc( var(--grid-2) * 2)" style={{ width: "calc(50vw)", height: "calc(50vh)" }}>
			<input
				type="text"
				defaultValue={search}
				onChange={(e) => {
					onSearchUpdate(e.target.value);
				}}
				placeholder="Søk etter navn, telefonnummer eller e-post"
			/>
			<Flex direction={Direction.column} gap="var(--grid-2)">
				{loading &&
					Array.from(Array(20)).map((u, i) => (
						<InfoRow interactive key={i}>
							<InfoColumn width="100%">
								<Skeleton />
							</InfoColumn>
						</InfoRow>
					))}
				{!loading &&
					data?.paginatedUsers?.items
						?.filter((u) => !u.groupIds?.find((g) => g === props.groupId))
						.map((user) => (
							<InfoRow interactive key={user.userId}>
								<InfoColumn width="15%">
									<AddButton
										disabled={addUserLoading}
										onClick={async () =>
											await addUserToGroup({
												variables: {
													userId: user.userId ?? "",
													groupId: props.groupId ?? "",
												},
												refetchQueries: ["GetUsersOnGroup", "GetGroup"],
											})
										}
									>
										<FontAwesomeIcon icon={faPlus} />
									</AddButton>
								</InfoColumn>
								<InfoColumn width="85%">{user.name}</InfoColumn>
							</InfoRow>
						))}
			</Flex>
		</FindUserModalContentWrapper>
	);
}

const FindUserModalContentWrapper = styled(Flex)`
	width: 50vw;
	height: 50vh;
	min-width: 300px;
	min-height: 300px;
	max-height: 100%;
	padding: 16px;
`;

export const AddButton = styled.button`
	padding: 10px;
	height: 50px;
	width: 50px;
`;
export const RemoveButton = styled(AddButton)`
	background-color: #cc2c2c;
	border-color: #cf4040;
`;
